import { ConditionalStyles } from 'react-data-table-component';
import { DropdownIfc, OPERATORS, TYPES } from '../utility-list';
import { ListColumnFilter } from './ListColumnFilter';

export class ListColumn<T extends {} = {}> {
  name: string;
  prop: keyof T;
  selector: (row: T) => string | number | boolean;
  sortable: boolean;
  sortField: keyof T;
  filterable: boolean;
  grow: number;
  format?: (row: T) => string | JSX.Element;
  cell?: (row: T) => JSX.Element;
  filter?: ListColumnFilter;
  conditionalCellStyles?: ConditionalStyles<T>[];

  constructor(
    prop: keyof T,
    name: string,
    grow: number,
    withFilter?: boolean,
    type?: TYPES,
    operator?: OPERATORS,
    reverseForCheckBox?: boolean
  ) {
    this.prop = prop;
    this.name = name;
    this.selector = (row: T) => `${row[prop]}`;
    this.sortable = true;
    this.sortField = prop;
    this.filterable = true;
    this.grow = grow;

    if (withFilter) {
      if (!type) type = TYPES.INPUT;
      if (!operator) operator = OPERATORS.CONTAINS;
      this.filter = new ListColumnFilter(type, operator, name, prop as string, grow, reverseForCheckBox);
    }
  }

  setContextForDropDown(context: DropdownIfc[]) {
    if (this.filter) {
      this.filter.contextForDropdown = context;
    }
    return this;
  }

  setFormat(format: (row: T) => string | JSX.Element) {
    this.format = format;
    return this;
  }

  setConditionalCellStyles(condStyles: ConditionalStyles<T>[]) {
    this.conditionalCellStyles = condStyles;
    return this;
  }
}
